<form class="flexer padding no-top-padding">
  <board-part-form
    *ngFor="let boardPart of inputProduct.boardParts; let index = index"
    [board]="inputProduct"
    [boardPart]="boardPart"
    [index]="index"
    [client]="client"
    (update)="outputBoard.emit()"
    (delete)="delete(index)"
  ></board-part-form>

  <div>
    <div
      *ngIf="client && inputProduct.boardParts.length <= 1"
      class="form-sub-title"
    >
      Wenst u meerdere projectborden op deze locatie:
    </div>
    <button class="button" (click)="addBoardPart()" type="button" mat-button>
      Extra bord toevoegen
    </button>
  </div>

  <design-picker
    *ngIf="!client && !fromOldSystem"
    [inputProduct]="inputProduct"
    [inputProject]="inputProject"
    [disabled]="disabled"
    (updateProduct)="outputBoard.emit()"
  >
  </design-picker>
</form>
<internal-project-form
  *ngIf="!client && !fromOldSystem"
  [inputProject]="inputProject"
  [inputProduct]="inputProduct"
  [involvedCompanies]="involvedCompanies"
  [pmsColorAdded]="pmsColorAdded"
  (updateProduct)="outputBoard.emit()"
></internal-project-form>
